/* eslint-disable no-restricted-globals */
import { useEffect } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { CloudinaryPicture, Grid, GridItem } from '@bwoty-web/ui-kit';
import { useIsGlobetrotter } from '@bwoty-web/ui-kit/hooks';
import TreeList from './treeList/treeList';
import './worldTreeView.scss';

const WorldTreeView = ({ selectedId = null, regions }) => {
  const isGlobetrotter = useIsGlobetrotter();

  const imageSizes = [
    {
      width: 392,
      height: isGlobetrotter ? 522 : 261,
      breakpoint: 768,
    },
    {
      width: 450,
      height: isGlobetrotter ? 600 : 300,
      breakpoint: 416,
    },
    {
      width: 415,
      height: isGlobetrotter ? 490 : 245,
    },
  ];

  useEffect(() => {
    if (selectedId) {
      if (typeof history !== 'undefined' && 'scrollRestoration' in history) {
        // Prevent browser's automatic scrollRestoration
        history.scrollRestoration = 'manual';
      }
      // Scroll to previously selected item
      document.getElementById(`id_${selectedId}`).scrollIntoView(true);
    }
  }, [selectedId]);

  return (
    <Grid className="gw-world-tree">
      {regions?.map((region) => {
        return (
          <GridItem columnSpan={4} key={`region_${region.id}`}>
            <div className={cx('gw_world-tree__item', { 'uikit-box--without-padding': !isGlobetrotter })}>
              {(region?.defaultImage || region?.topImageCloudinary) && (
                <CloudinaryPicture
                  img={region?.topImageCloudinary || region?.defaultImage}
                  className="gw-world-tree__region-image"
                  sizes={imageSizes}
                  retina
                />
              )}
              <div className="gw-world-tree__region">
                <a href={region?.url}>
                  <h2 className="gw-world-tree__region-name">{region?.name}</h2>
                </a>
                {region?.destinations?.map((destination) => {
                  return (
                    <TreeList
                      tree={destination}
                      key={destination.id}
                      selectedId={selectedId}
                    />
                  );
                })}
              </div>
            </div>
          </GridItem>
        );
      })}
    </Grid>
  );
};

WorldTreeView.propTypes = {
  regions: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      url: PropTypes.string,
      id: PropTypes.string.isRequired,
      destinations: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    }),
  ).isRequired,
  selectedId: PropTypes.string,
};

export default WorldTreeView;
